//
import contribuyentesMachine from "./machine"
import { actionsNoCare } from "../../constants/actionsNoCare"
export const { initialState } = contribuyentesMachine

const Contribuyentes = (state = initialState, action) => {
  //
  if (
    !actionsNoCare.includes(action.type) &&
    !action.type.startsWith("@@") &&
    action.type.startsWith("contribuyentes/")
  ) {
    if (!contribuyentesMachine.states[state.value]?.on?.[action.type]) {
      console.error(
        `contribuyentesMachine: No hay transición definida para la acción ${action.type} en el estado ${state.value}`
      )
    } else {
      return contribuyentesMachine.transition(state, action)
    }
  }
  return state
}

export default Contribuyentes
